<!-- eslint-disable -->
<template lang="pug">
    div
        .form__title
            slot(name='title')
        form.form__body(action='javascript://' v-if='params')
            .form__field(v-if="gameMode !== 'course'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_topics') }}
                .form__field-body
                    cs-multiselect(
                        :options="topics"
                        :show-labels="false"
                        :hide-selected="true"
                        :max="null"
                        :close-on-select="false"
                        :clear-on-select="false"
                        placeholder=""
                        :multiple="true"
                        v-model="selectedTopics"
                        track-by='mode',
                        label='name',
                        :disabled="topics.length === 0"
                        v-validate="'required'"
                        data-vv-value-path="innerValue"
                        data-vv-name="topics"
                        :data-vv-as="$i18n.t('homework.homework_create_studentsVvSs')"
                    )
            .form__field(v-if="gameMode !== 'course'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_searchTopic') }}
                .form__field-body
                    cs-multiselect(
                        :options="selectedTopics"
                        :show-labels="false"
                        :hide-selected="true"
                        :max="null"
                        :close-on-select="true"
                        placeholder=""
                        :multiple="false"
                        v-model="selectedSearchTopic"
                        track-by='mode',
                        label='name',
                        :disabled="selectedTopics.length < 2"
                        v-validate="'required'"
                        data-vv-value-path="innerValue"
                        data-vv-name="topic"
                        :data-vv-as="$i18n.t('homework.homework_create_studentsVvSs')"
                    )
            .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfRequired') }}
                .form__field-body
                    cs-spin-input(
                        :value="params.numOfUnknowns",
                        :max="numOfUnknowns",
                        :min="3",
                        @increase="increaseNumOfUnknowns"
                        @decrease="decreaseNumOfUnknowns",
                        @input="params.numOfUnknowns = $event",
                    )
            .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}
                .form__field-body
                    cs-spin-input(
                        :value="params.numOfExamples",
                        :max="numOfExamples",
                        :min="1",
                        @increase="increaseNumOfExamples",
                        @decrease="decreaseNumOfExamples",
                        @input="params.numOfExamples = $event",
                    )
            .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_tableSize') }}
                .form__field-body
                    cs-multiselect(
                        :options="availableTableSizes"
                        v-model="params.tableSize"
                        :placeholder="tableLabel(params.tableSize)"
                        :custom-label="tableLabel"
                        :multiple="false"
                        :allow-empty="false"
                    )
            divider
            slot(name='parameters')
            slot(name='help')
            .form__buttons(v-if='!usersIds')
                cs-button.form__button(@click='cancel', color="blue", pattern="primary-outline")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                template(v-if="gameMode === 'free-game'")
                    cs-button.form__button(color="blue", @click='saveGameMode' :disabled="isSaveButtonDisabled")
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
                template(v-else='')
                    cs-button.form__button(color="blue", @click='saveGame' :disabled="isSaveButtonDisabled")
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
            .form__buttons(v-else='')
                cs-button.form__button(@click='cancel', color="blue", pattern="primary-outline")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                cs-button.form__button(color="blue", @click='saveGame' :disabled="isSaveButtonDisabled")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_saveDifference') }}
</template>

<script>
    /*eslint-disable*/
    import GameFormMixin from "../../../utils/trainer/GameFormMixin";
    import TrainerGames from '../../../config/trainer';
    import { getInitParameters } from "../../../utils/trainer/getInitParameters";
    import { mapState } from 'vuex';
    import _ from "lodash";
    import multiplayerFormMixin from "../../../utils/multiplayer/formMixin";
    import SearchGameApi from '../../../api/games/searchGameApi'
    const MIN_IMAGE_AMOUNT_IN_TOPIC = 18

    export default {
        props: {
            slug: String,
            courseType: String,
            id: [Number, String],
            usersIds: [Array, String],
            homeworkId: [Number, String],
            gameMode: String,
            gameId: [Number, String],
            generatorGameIndex: Number,
            generatorSettings: Boolean,
            levelAnswerDuration: Number,
        },
        mixins: [GameFormMixin, multiplayerFormMixin],
        data () {
            return {
                imageGroups: [],
                selectedSearchTopic: null,
                selectedTopics: [],
                params: null,
                numOfUnknowns: 15,
                numOfExamples: 100,
            }
        },
        mounted() {
            this.getTopics();
            if (this.gameMode === 'free-game') {
                let paramsArray = this.$store.state.trainer.paramsArray;
                if (paramsArray && paramsArray[0] && paramsArray[0].slug === this.slug) {
                    this.paramsArray = _.cloneDeep(paramsArray);
                    this.$emit('playersNumber', this.paramsArray.length);
                    this.params = this.paramsArray[0];
                } else if (this.gamesParameters) {
                    this.$set(this, 'params', getInitParameters({
                        slug: this.slug,
                        parameters: {
                            default: _.cloneDeep(this.gamesParameters[this.slug])
                        }
                    }));
                } else {
                    this.params = _.cloneDeep(TrainerGames.games).find(item => item.slug === this.slug).parameters.default;
                }
            } else {
                this.setInitParams(this.getKey(this.usersIds));
            }
            if (this.params.searchTopic) {
                this.selectedSearchTopic = {name: this.$i18n.t('trainer.trainer_gameFormSettingValue_' + this.params.searchTopic) , mode: this.params.searchTopic};
            }
            if (this.params.selectedTopics && this.params.selectedTopics.length) {
                this.selectedTopics = this.params.selectedTopics.map(topic => {
                    return {name: this.$i18n.t('trainer.trainer_gameFormSettingValue_' + topic) , mode: topic};
                });
            }
        },
        computed: {
            ...mapState({
                homework: state => state.trainer.homework,
                gamesParameters: state => state.trainer.gamesParameters,
                user: state => state.auth.user
            }),
            topics () {
                return this.imageGroups.map(topic => {
                    return {name: this.$i18n.t('trainer.trainer_gameFormSettingValue_' + topic) , mode: topic}
                }).sort(this.sortTopicsByName)
            },
            isSaveButtonDisabled () {
                return this.selectedTopics.length < 2 || !this.selectedSearchTopic
            },
            availableTableSizes () {
                return Array.from(Array(6), (_, i) => i + 1).slice(1)
                    .filter(num => this.isTableSizeFits(num))
            }
        },
        watch: {
            'params.numOfUnknowns': {
                handler (val) {
                    if (val >= this.params.tableSize * this.params.tableSize) {
                        this.params.tableSize = Math.ceil(Math.sqrt(val + 1))
                    }
                }
            },
            'selectedSearchTopic': {
                handler (val) {
                    val && (this.params.searchTopic = val.mode);
                },

            },
            'selectedTopics': {
                handler (val) {
                    val && (this.params.selectedTopics = val.map(topic => topic.mode));
                    if (this.selectedSearchTopic) {
                        if (!this.params.selectedTopics.includes(this.selectedSearchTopic.mode)) {
                            this.selectedSearchTopic = null;
                            this.searchTopic = null;
                        }
                    }
                },
                deep: true
            },
        },
        methods: {
            getTopics () {
                SearchGameApi.getGroups(this.user.locale)
                .then(data => this.imageGroups = data.imageGroups);
            },
            sortTopicsByName (firstTopic, secondTopic) {
                const firstTopicName = firstTopic.name.toUpperCase();
                const secondTopicName = secondTopic.name.toUpperCase();
                if (firstTopicName < secondTopicName) {
                    return -1;
                } else if (firstTopicName > secondTopicName) {
                    return 1;
                }
                return 0;
            },
            isTableSizeFits (number) {
                const maxTableSize = this.params.numOfUnknowns
                        + MIN_IMAGE_AMOUNT_IN_TOPIC * (this.params.selectedTopics.length - 1);
                return number >= 2
                        && this.params.numOfUnknowns < Math.pow(number, 2)
                        && maxTableSize > Math.pow(number, 2);
            },
            tableLabel (num) {
                return num + ' x ' + num;
            },
            decreaseNumOfUnknowns(){
                if (this.params.numOfUnknowns !== 3) {
                    this.params.numOfUnknowns -= 1;
                }
            },
            increaseNumOfUnknowns() {
                if (this.params.numOfUnknowns !== this.numOfUnknowns) {
                    this.params.numOfUnknowns += 1;
                }
            },
            decreaseNumOfExamples() {
                if (this.params.numOfExamples !== 1) {
                    this.params.numOfExamples -= 1;
                }
            },
            increaseNumOfExamples() {
                if (this.params.numOfExamples !== this.numOfExamples) {
                    this.params.numOfExamples += 1;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .form__title {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        margin-bottom: 25px;
    }

    .form__body {
        width: 100%;
        box-sizing: border-box;
        @include media($lg) {
            padding: 0 4.5%;
        }
    }

    .form__field {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        @include media($md) {
            padding: 0 2.5px;
            flex-direction: row;
            align-items: center;
        }
        @include media($lg) {
            padding: 0 10%;
        }
        @include media($xlg) {
            padding: 0 13%;
        }
    }

    .form__field--column {
        flex-direction: column;
        margin-bottom: 20px;
        align-items: flex-start;
    }

    .form__label {
        min-width: 0;
        font-size: 16px;
        line-height: 19px;
        margin-right: 20px;
        margin-bottom: .5rem;
        @include media($md) {
            width: 8em;
            margin-bottom: 0;
            text-align: right;
        }
        @include media($xlg) {
            max-width: none;
            min-width: 13em;
        }
    }

    .form__label--left {
        min-width: 0;
        width: auto;
        margin-bottom: 20px;
    }

    .form__field-body {
        flex-grow: 5;
    }

    .form__field-body--inline {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }

    .numbers-checkbox:not(:last-child) {
        margin-right: 10px;
    }

    .form__buttons {
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        @include media($md) {
            flex-direction: row;
        }
    }

    .form__button {
        margin: 10px 50px;
        @include media($md) {
            margin: 0 10px;
        }
    }
</style>

